import Modal from "../../../UiComponents/Modal/Modal";
import modalStyle from "./ListingFullDisplay.module.css";

const ListingFullDisplayPlaceHolder = ({}: {}) => {
  return (
    <>
      <Modal
        onClose={() => {}}
        className={modalStyle.style_modal}
        styleBackdrop={{ zIndex: "2009" }}
      >
        <div className={modalStyle.container}>
          <div>
            <div></div>
          </div>

          <div></div>

          <div className={modalStyle.informationsContainer}></div>
        </div>
      </Modal>
    </>
  );
};

export default ListingFullDisplayPlaceHolder;
